export const JOB_REQUIRED_SKILLS: string[] = [
    'JavaScript',
    'React',
    'Python',
    'Java',
    'SQL'
];